import axios from './axios-auth';

const getAllClientsProgram = (params) =>
  new Promise((resolve, reject) => {
    axios({
      url: '/hr-adm/getauthorizedclientsprograms',
      params: params,
      method: 'GET',
    })
      .then((resp) => {
        if (resp.status !== 200) {
          reject(resp.data.message);
        }
        resolve(resp.data);
      })
      .catch(() => {
        console.log('error while response in batch user upload api');
      });
  });

const getUsersForBatchUploadFile = (params) =>
  new Promise((resolve, reject) => {
    try {
      axios({
        url: '/hr-adm/getnewusersforbatchexport',
        data: params,
        method: 'POST',
        responseType: 'blob',
      })
        .then((resp) => {
          if (resp.status !== 200) {
            reject(resp.data.message);
          }
          resolve(resp.data);
        })
        .catch(() => {
          console.log('error from get user for batch upload api');
        });
    } catch (error) {
      console.log(error);
    }
  });

const getUserUploadSummary = () =>
  new Promise((resolve, reject) => {
    axios({
      url: '/hr-adm/getuseruploadsummary',
      method: 'GET',
    })
      .then((resp) => {
        if (resp.status !== 200) {
          reject(resp.data.message);
        }
        resolve(resp.data);
      })
      .catch(() => {
        console.log('error from get user summary');
      });
  });

const getUsersForPreview = (params) =>
  new Promise((resolve, reject) => {
    axios({
      url: '/hr-adm/getusersforpreview',
      params: params,
      method: 'GET',
    })
      .then((resp) => {
        if (resp.status !== 200) {
          reject(resp.data.message);
        }
        resolve(resp.data);
      })
      .catch(() => {
        console.log('error from get user summary');
      });
  });

const getUserDetailForPreviewByUploadId = (params) =>
  new Promise((resolve, reject) => {
    axios({
      url: '/hr-adm/getuserdetailsforpreview',
      params: params,
      method: 'GET',
    })
      .then((resp) => {
        if (resp.status !== 200) {
          reject(resp.data.message);
        }
        resolve(resp.data);
      })
      .catch(() => {
        console.log('error from get user summary');
      });
  });

const deleteUserRecordByUploadId = (params) =>
  new Promise((resolve, reject) => {
    axios({
      url: '/hr-adm/deleteuserpreview',
      params: params,
      method: 'DELETE',
    })
      .then((resp) => {
        if (resp.status !== 200) {
          reject(resp.data.message);
        }
        console.log(resp, 'from api');
        resolve(resp.status);
      })
      .catch(() => {
        console.log('error from get user summary');
      });
  });

const editUserRecordsByUploadId = (params) =>
  new Promise((resolve, reject) => {
    axios({
      url: '/hr-adm/updateuserforpreviewbyuploadid',
      data: params,
      method: 'PUT',
    })
      .then((resp) => {
        if (resp.status !== 200) {
          reject(resp.data.message);
        }
        resolve(resp.data);
      })
      .catch(() => {
        console.log('error from get user summary');
      });
  });

const addUserFileData = (formData) =>
  new Promise((resolve, reject) => {
    axios({
      url: '/hr-adm/uploadbatchuserdetails',
      data: formData,
      method: 'POST',
      headers: { 'Content-Type': 'multipart/form-data' },
    })
      .then((resp) => {
        if (resp.status !== 200) {
          reject(resp.data.message);
        }
        resolve(resp.status);
      })
      .catch(() => {
        console.log('error from get user summary');
      });
  });

const addUserJSONData = async (data) => {
  try {
    const resp = await axios({
      url: '/hr-adm/uploadbatchuserdetailsjson',
      data: data,
      method: 'POST',
    })

    if (resp.status != 200) {
      console.error(`Response wasn't 200: ${resp.status}`)
    }

    return resp
  }
  catch (e) {
    console.error(e)
  }
}

const addFinalUserRecords = () =>
  new Promise((resolve, reject) => {
    axios({
      url: '/hr-adm/finalizeusers',
      method: 'POST',
    })
      .then((resp) => {
        if (resp.status !== 200) {
          reject(resp.data.message);
        }
        console.log(resp);
        resolve(resp.status);
      })
      .catch(() => {
        console.log('error from add final users api');
      });
  });

const deleteAllPendingRecords = () =>
  new Promise((resolve, reject) => {
    axios({
      url: '/hr-adm/deleteuserspreview',
      method: 'DELETE',
    })
      .then((resp) => {
        if (resp.status !== 200) {
          reject(resp.data.message);
        }
        resolve(resp.status);
      })
      .catch(() => {
        console.log('error from add final users api');
      });
  });

const updateExistingUserInfo = () =>
  new Promise((resolve, reject) => {
    axios({
      url: '/hr-adm/updatebatchusers',
      method: 'PUT',
    })
      .then((resp) => {
        if (resp.status !== 200) {
          reject(resp.data.message);
        }
        resolve(resp.status);
      })
      .catch(() => {
        console.log('error from update existing user api');
      });
  });

const uploadUserFileAllOnce = (payload) =>
  new Promise((resolve, reject) => {
    axios({
      url: '/hr-adm/updatenewusers',
      data: payload,
      method: 'PUT',
    })
      .then((resp) => {
        if (resp.status !== 200) {
          reject(resp.data.message);
        }
        resolve(resp.status);
      })
      .catch(() => {
        console.log('error from update existing user api');
      });
  });

const getuserprogramsummary = () =>
  new Promise((resolve, reject) => {
    axios({
      url: '/hr-adm/getuserprogramsummary',
      method: 'GET',
    })
      .then((resp) => {
        if (resp.status !== 200) {
          reject(resp.data.message);
        }
        resolve(resp.data);
      })
      .catch(() => {
        console.log('error from get user program summary api');
      });
  });

const updateBatchUsersWithPoints = (payload) =>
  new Promise((resolve, reject) => {
    axios({
      url: '/hr-adm/updatebatchuserswithpoints',
      data: payload,
      method: 'PUT',
    })
      .then((resp) => {
        if (resp.status !== 200) {
          reject(resp.data.message);
        }
        resolve(resp.status);
      })
      .catch(() => {
        console.log('error from get user program summary api');
      });
  });

const updateBatchUsersWithDeletePoints = (payload) =>
  new Promise((resolve, reject) => {
    axios({
      url: '/hr-adm/updatebatchuserswithdeletepoints',
      data: payload,
      method: 'PUT',
    })
      .then((resp) => {
        if (resp.status !== 200) {
          reject(resp.data.message);
        }
        resolve(resp.status);
      })
      .catch(() => {
        console.log('error from get user program summary api');
      });
  });

const downloadExcelFile = (params) =>
  new Promise((resolve, reject) => {
    axios({
      url: '/hr-adm/downloadfile',
      method: 'GET',
      params: params,
      responseType: 'blob',
    })
      .then((resp) => {
        if (resp.status !== 200) {
          reject(resp);
        }
        resolve(resp.data);
      })
      .catch(() => {
        console.log('error downloadExcelFile api');
      });
  });

const downloadBlankTemplate = (params) =>
  new Promise((resolve, reject) => {
    axios({
      url: '/hr-adm/downloadfile',
      method: 'GET',
      params: params,
      responseType: 'blob',
    })
      .then((resp) => {
        if (resp.status !== 200) {
          reject(resp);
        }
        resolve(resp.data);
      })
      .catch(() => {
        console.log('error downloadBlankTemplate api');
      });
  });

const getUserLastLockDate = (payload) => {
  console.log(payload);
  return new Promise((resolve, reject) => {
    axios({
      url: '/hr-adm/getuserlastlockdate',
      data: payload,
      method: 'POST',
    })
      .then((resp) => {
        if (resp.status !== 200) {
          reject(resp);
        }
        resolve(resp.data);
      })
      .catch(() => {
        console.log('error from get user program summary api');
      });
  });
};

export {
  getAllClientsProgram,
  getUsersForBatchUploadFile,
  getUserUploadSummary,
  getUsersForPreview,
  getUserDetailForPreviewByUploadId,
  deleteUserRecordByUploadId,
  editUserRecordsByUploadId,
  addUserFileData,
  addFinalUserRecords,
  deleteAllPendingRecords,
  updateExistingUserInfo,
  uploadUserFileAllOnce,
  getuserprogramsummary,
  updateBatchUsersWithPoints,
  downloadExcelFile,
  downloadBlankTemplate,
  updateBatchUsersWithDeletePoints,
  getUserLastLockDate,
  addUserJSONData
};
